import { Button, useMediaQuery } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { useExperienceEnrollmentContext } from '../../../../../Common/ProgramExperienceEnrollment';
import { getButtonSize } from './Types';

function GetStartedButton() {
  const { onOpen } = useExperienceEnrollmentContext();
  const breakPoint = useMediaQuery();

  return (
    <Button
      className="min-w-full bg-white sm:min-w-48"
      color="gray"
      radius="md"
      variant="text"
      size={getButtonSize(breakPoint)}
      data-intercom-target="group-coaching-get-started-button"
      onClick={onOpen}
    >
      <T kind="Get Started" />
    </Button>
  );
}

export default observer(GetStartedButton);
